import React, { useState } from 'react';
import { BrowserRouter , Routes, Route } from 'react-router-dom';
import Home from './Pages/splash'
import Level1 from './Pages/Level1';
import IntroCutscene from './Pages/IntroCutscene';
import FixCutscene from './Pages/FixCutscene';
import Level2 from './Pages/Level2';
import FixedCutscene from './Pages/FixedCutscene';
import ApproachCutscene from './Pages/ApproachCutscene';
import Level3 from './Pages/Level3';
import Level4 from './Pages/Level4';
import ShipCutscene from './Pages/ShipCutscene';
import InfiniteLevel from './Components/Common/InfiniteLevel';



const RouteUrls = () => {

    const [musicVolume, setMusicVolume] = useState(50);
    const [sfxVolume, setSfxVolume] = useState(70);

    return ( 
        <BrowserRouter>
            <Routes>
                <Route 
                    path='/' 
                    element={
                        <Home 
                            musicVolume={musicVolume} 
                            setMusicVolume={setMusicVolume} 
                            sfxVolume={sfxVolume} 
                            setSfxVolume={setSfxVolume} 
                        />
                    } 
                />

                <Route 
                    path='/Intro' 
                    element={
                        <IntroCutscene 
                            musicVolume={musicVolume} 
                            sfxVolume={sfxVolume} 
                        />
                    } 
                />
                
                <Route 
                    path='/L1' 
                    element={
                        <Level1 
                            musicVolume={musicVolume} 
                            sfxVolume={sfxVolume} 
                        />
                    } 
                />
                <Route 
                    path='/fix' 
                    element={
                        <FixCutscene 
                            musicVolume={musicVolume} 
                            sfxVolume={sfxVolume} 
                        />
                    } 
                />
                <Route 
                    path='/L2' 
                    element={
                        <Level2
                            musicVolume={musicVolume} 
                            sfxVolume={sfxVolume} 
                        />
                    } 
                />
                <Route 
                    path='/fixed' 
                    element={
                        <FixedCutscene
                            musicVolume={musicVolume} 
                            sfxVolume={sfxVolume} 
                        />
                    } 
                />
                <Route 
                    path='/approach' 
                    element={
                        <ApproachCutscene
                            musicVolume={musicVolume} 
                            sfxVolume={sfxVolume} 
                        />
                    } 
                />
                <Route 
                    path='/L3' 
                    element={
                        <Level3
                            musicVolume={musicVolume} 
                            sfxVolume={sfxVolume} 
                        />
                    } 
                />
                <Route 
                    path='/Ship' 
                    element={
                        <ShipCutscene
                            musicVolume={musicVolume} 
                            sfxVolume={sfxVolume} 
                        />
                    } 
                />
                <Route 
                    path='/L4' 
                    element={
                        <Level4
                            musicVolume={musicVolume} 
                            sfxVolume={sfxVolume} 
                        />
                    } 
                />
                <Route 
                    path='/infinite' 
                    element={
                        <InfiniteLevel
                            musicVolume={musicVolume} 
                            sfxVolume={sfxVolume} 
                        />
                    } 
                />
            </Routes>
        </BrowserRouter>
     );
}
 
export default RouteUrls;